import type { NewPendingPostData, PendingPost } from './types'

export const generateBasicPost = (userId: string, data: NewPendingPostData): PendingPost => {
  const { answer, message, file, timeStamp, payload, ...rest } = data
  return {
    id: timeStamp,
    create_at: timeStamp,
    update_at: timeStamp,
    props: {
      localId: timeStamp,
      answer: JSON.stringify(answer),
      payload: payload,
      ...rest,
    },
    message: message || (answer && answer.text) || '',
    user_id: userId,
    localFile: file?.file ? file.file : file?.fileUri,
    fileName: file?.fileName,
    fileType: file?.fileType,
    isLocal: true,
  }
}
